import React from "react";

interface ZaunCircleMenuItemProps {
  onClick?: ((event: React.MouseEvent<HTMLButtonElement>) => void) | null;
  children?: React.ReactNode;
  dataButtonKey?: string;
  className?: string;
}

export function ZaunCircleMenuItem({
  onClick = null,
  children,
  dataButtonKey = undefined,
  className = "",
}: ZaunCircleMenuItemProps) {
  return (
    <div
      data-button-key={dataButtonKey}
      className={className + " zaunCircleMenuItem popup hidden fade display-none"}
    >
      {onClick == null ? (
        <div className="rounded namedIcon svg-line-like-border hover-shadow">{children}</div>
      ) : (
        <button
          className="rounded namedIcon svg-line-like-border hover-shadow"
          onClick={onClick}
          aria-label={dataButtonKey || "Aktion"}
          type="button"
        >
          {children}
        </button>
      )}
    </div>
  );
}
